import Component from "@glimmer/component"
import styles from "./text-block.module.css"

export default class PlannerCardStacksCardsPartsTextBlockComponent extends Component {
  readonly styles = styles
}
